<template>
  <div 
    :class="`giving-bottom-banner-mobile ${collapsed ? 'collapsed' : ''}`"
    :style="{'background-color' : streamSettings.give_banner.colors.background}"  v-if="isGiveBannerEnabledInPlayer && (isGivingBannerShow || isTimeframeBannerVisible)"
  >
    <button 
      class="gbm-chevron" 
      @click="toggleCollapse"
      :style="{'background-color' : streamSettings.give_banner.colors.background}"
    >
        <svg 
          v-if="!collapsed" 
          width="24" 
          height="24" 
          viewBox="0 0 24 24">
          <path 
            d="M12 15.5l-7-7 1.41-1.42L12 12.67l5.59-5.59L19 8.5z" 
            :fill="streamSettings.give_banner.colors.text"/>
        </svg>
        <svg 
          v-else 
          width="24" 
          height="24" 
          viewBox="0 0 24 24">
          <path 
            d="M12 8.5l7 7-1.41 1.42L12 11.33l-5.59 5.59L5 15.5z" 
            :fill="streamSettings.give_banner.colors.text"/>
        </svg>
    </button>
    <div class="gbm-inner">
      <div 
        class="gbm-caption"
        :style="{color: streamSettings.give_banner.colors.text}"
      >
        <span>{{ streamSettings.give_banner.description }}</span>
      </div>
      <button
        v-if="!collapsed"
        class="gbm-cta"
        :style="{'background-color': streamSettings.give_banner.colors.button,'color': streamSettings.give_banner.colors.text}"
        @click="openGiveModel"
      >
        {{ givingBannerButtonText }}
      </button>
    </div>
    <div v-if="collapsed" class="gbm-collapsed-text">
      <span>{{ streamSettings.give_banner.description }}</span>
    </div>
    <div v-if="showPopupModel" class="modal-overlay">
      <div id="custom-give-form-modal" ref="customGiveFormModal" :v-model="showPopupModel" role="dialog"
           tabindex="-1" class="modal fade show d-block" aria-modal="true">
        <div class="modal-dialog modal-md">
          <div role="document" id="custom-give-form-modal___BV_modal_content_"
               aria-labelledby="custom-give-form-modal___BV_modal_header_"
               aria-describedby="custom-give-form-modal___BV_modal_body_" class="modal-content">
            <div>
              <!-- Custom Loader - how spinner while the script is being loaded  -->
              <div v-if="isLoadingGracePeriod" class="custom-loader-container">
                <div class="custom-loader"></div>
                <p>Loading...</p>
              </div>

              <!-- Show message only if the script has failed -->
              <div v-if="!giveFormScriptLoaded && !isLoadingGracePeriod" class="give-form-not-found">
                <p>Give Form is not available at the moment.</p>
              </div>

              <!-- The form container should always be present -->
              <div id="popup-give-form-container">
                <span v-if="!isLoadingGracePeriod" class="close" @click="hideGivePopupModal">×</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div tabindex="0"></div>
      <div id="custom-give-form-modal___BV_modal_backdrop_" class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'GivingBottomBannerMobile',
  props: {
        streams: Object,
        streamSettings: Object,
        isStreaming: Boolean,
        disableGiveButtonForDashboard: Boolean,
    },
    watch: {
        // Watch for changes to the `isStreaming` prop
        isStreaming(newValue) {
            // Perform any additional logic when the stream status changes
            this.isGiveBannerVisible();
        },
        streamSettings: {
            handler() {
                //This should be runs every time the data changes.
                this.isGiveBannerVisible();
            },
            deep: true,
            immediate: true
        }

    },
    data() {
        return {
            collapsed: false,
            currentStream: undefined,
            dark: true,
            isGivingBannerShow: false,
            isGivingBottomBarOpen: false,
            showPopupModel: false,
            giveFormScriptLoaded: false,
            isTimeframeBannerVisible: false,
            isSetTimeBannerVisible: false, // For set time banner visibility
            isLoadingGracePeriod: false // Add a grace period flag
        }
    },
    computed: {
        givingBannerButtonText() {
            return (this.currentStream && this.currentStream.giving_banner_button_text && this.currentStream.giving_banner_button_text.trim())
                ? this.currentStream.giving_banner_button_text
                : (this.streamSettings && this.streamSettings.give_banner ? this.streamSettings.give_banner.button_text : '');
        },
        givingBannerQrCodeUrl() {
            return (this.currentStream && this.currentStream.giving_banner_qr_code_url && this.currentStream.giving_banner_qr_code_url.trim())
                ? this.currentStream.giving_banner_qr_code_url
                : (this.streamSettings && this.streamSettings.give_banner ? this.streamSettings.give_banner.banner_giving_qr_code_url : '');
        },
        isGiveBannerEnabledInPlayer() {

            const isGlobalEnabled =
                this.streamSettings &&
                this.streamSettings.give_banner &&
                this.streamSettings.give_banner.banner_giving_show_banner_in_player;

            const isStreamWiseEnabled = (this.streams && this.streams.data && this.streams.data.length > 0) ? this.streams.data[0].giving_banner : 0;

            if (Number(isStreamWiseEnabled) === 0) {
                return false; // If stream specific banner is disabled
            } else {
                return (!isGlobalEnabled) ? false : true; // If global banner is disabled return false else true.
            }
        },
        descriptionClass() {
            return this.streamSettings.give_banner.description.length <= 30 ? 'line-one' : 'line-two';
        }
    },
    created() {
        this.currentStream = this.streams ? this.streams.data[0] : null;
        // Now we can safely set isGivingBannerShow with initialized isStreaming
        this.isGiveBannerVisible();
    },
    methods: {
        toggleCollapse() {
            this.collapsed = !this.collapsed;
        },

        toggleAccordion() {
            const delay = this.isGivingBottomBarOpen ? 100 : 30; // Set delay dynamically

            this.isGivingBottomBarOpen = !this.isGivingBottomBarOpen;

            setTimeout(() => {
                const height = document.body.offsetHeight;
                window.parent.postMessage(['AccordionChange', height], '*');
            }, delay);
        },

        openGiveModel() {
            this.showPopupModel = true;

            const scriptSource = this.streamSettings.give_banner.banner_giving_form_url;
            const externalcss = this.streamSettings.give_banner.externalcss;

            // Extract the domain and formid
            const url = new URL(scriptSource);
            const endpoint = `${url.protocol}//${url.host}`; // Extract the domain
            const formId = this.currentStream && this.currentStream.giving_banner_form_id
                ? (this.currentStream.giving_banner_form_id.trim() !== '' ? this.currentStream.giving_banner_form_id : url.searchParams.get("formid"))
                : url.searchParams.get("formid"); // Extract the formid parameter
            let externalJsonData = (this.currentStream) ? `stream_id:${this.currentStream.id},form_experience:banner` : '';

            // Construct the new URL
            // SourceID 16 is for Streaming Banner (Bottom banner)
            const newScriptSource = `${endpoint}/embed.aspx?formId=${formId}&set-page-title=false&button-class=sites-button&use-default-theme=true&button-class=sites-button&style-url=${externalcss}&source=16&external-data=${externalJsonData}`;

            // Ensure the script is injected after the modal is rendered
            this.$nextTick(() => {
                this.injectGiveForm("popup-give-form-container", newScriptSource);
            });
        },

        /**
         * Inject the Give Form Script dynamically into the DOM
         */
        injectGiveForm(targetElementId, scriptSource) {
            if (!scriptSource) {
                console.error("Give Form script source URL is missing.");
                return;
            }

            const container = document.getElementById(targetElementId);

            if (!container) {
                console.error(`Target element with ID "${targetElementId}" not found.`);
                return;
            }

            // Start a grace period timer
            this.isLoadingGracePeriod = true;

            // Check if the script is already loaded
            if (!document.querySelector(`#${targetElementId} script`)) {
                const script = document.createElement("script");
                script.id = "giveFormScript";
                script.src = scriptSource;
                script.async = true;

                // Mark the script as loaded once it finishes loading
                script.onload = () => {
                    this.giveFormScriptLoaded = true;
                    this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
                };

                script.onerror = () => {
                    this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
                    console.error("Failed to load the Give Form script.");
                };

                // Append the script to the container
                container.appendChild(script);
            } else {
                this.giveFormScriptLoaded = true; // Mark as loaded if already present
                this.markIsLoadingGracePeriodFalse(); // End the grace period immediately if script is already loaded
            }
        },

        hideGivePopupModal() {
            this.showPopupModel = false;

            // Reset the flags
            this.giveFormScriptLoaded = false;
            this.isLoadingGracePeriod = true;
        },

        markIsLoadingGracePeriodFalse() {
            setTimeout(() => {
                this.isLoadingGracePeriod = false; // End the grace period after script loads
            }, 1000); // Adjust the timeout as needed
        },

        /**
         * The function use to control the give banner visibility
         */
        isGiveBannerVisible() {
            const streamSettingsData = this.streamSettings;

            if (!streamSettingsData || !streamSettingsData.give_banner || !streamSettingsData.give_banner.banner_visibility) {
                // If streamSettings, give_banner, or banner_visibility is not defined, hide the banner
                this.isGivingBannerShow = false;
                this.isGivingBottomBarOpen = false;
                this.isTimeframeBannerVisible = false;
                return;
            }

            const bannerVisibility = streamSettingsData.give_banner.banner_visibility;
            const hasType = bannerVisibility.hasOwnProperty('type');
            const hasExpandedMode = bannerVisibility.hasOwnProperty('expanded_mode');

            if (hasType && hasExpandedMode) {
                const isAlwaysShow = bannerVisibility.type === 'always_show';
                const isControlWhileLive = bannerVisibility.type === 'control_while_live';
                const isSetTime = bannerVisibility.type === 'set_time';
                const isExpandedMode = bannerVisibility.expanded_mode === true;

                if (isSetTime) {
                    this.isSetTimeBannerVisible = true;
                    this.isGivingBannerShow = false;
                    this.isGivingBottomBarOpen = true;
                    this.checkBannerVisibility(); // Delegate visibility checks to checkBannerVisibility
                    this.setupTimer(); // Ensure the timer is set up for periodic checks
                } else if ((isAlwaysShow && isExpandedMode) || (isControlWhileLive && this.isStreaming && isExpandedMode)) {
                    this.isGivingBannerShow = true;
                    this.isGivingBottomBarOpen = true;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                } else if (isControlWhileLive && this.isStreaming && !isExpandedMode) {
                    this.isGivingBannerShow = true;
                    this.isGivingBottomBarOpen = false;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                } else {
                    this.isGivingBannerShow = false;
                    this.isGivingBottomBarOpen = false;
                    this.isTimeframeBannerVisible = false;
                    this.isSetTimeBannerVisible = false;
                }
            } else {
                // If type or expanded_mode is not defined, hide the banner
                this.isGivingBannerShow = false;
                this.isGivingBottomBarOpen = false;
                this.isTimeframeBannerVisible = false;
                this.isSetTimeBannerVisible = false;
            }
        },

        checkBannerVisibility: debounce(function () {

            // Ensure timeframes exist and currentStream is valid
            if (!this.currentStream || !this.isStreaming || !this.streamSettings.give_banner.timeframes || !this.isSetTimeBannerVisible) {
                this.isTimeframeBannerVisible = false;
                return;
            }

            try {
                const timeframes = JSON.parse(this.streamSettings.give_banner.timeframes);
                // Sort timeframes by showAfter in ascending order
                timeframes.sort((a, b) => parseFloat(a.showAfter) - parseFloat(b.showAfter));

                const streamStart = new Date(this.currentStream.start.carbon).getTime();
                const streamEnd = new Date(this.currentStream.end.carbon).getTime();
                const totalStreamMinutes = (streamEnd - streamStart) / 60000;
                const currentTime = Date.now();
                const elapsedMinutes = (currentTime - streamStart) / 60000;

                // Check if current time is within any valid timeframe
                this.isTimeframeBannerVisible = timeframes.some(({showAfter, showFor}) => {
                    const showAfterMinutes = parseFloat(showAfter);
                    const showForMinutes = parseFloat(showFor);

                    // Ignore timeframes that exceed the total stream length
                    if (showAfterMinutes + showForMinutes > totalStreamMinutes) {
                        return false;
                    }

                    return elapsedMinutes >= showAfterMinutes && elapsedMinutes <= showAfterMinutes + showForMinutes;
                });
            } catch (error) {
                console.error("Error parsing timeframes:", error);
                this.isTimeframeBannerVisible = false;
            }
        }, 500), // Debounce for 500ms

        // Setup a timer to check banner visibility every minute
        setupTimer() {
            if (this.isSetTimeBannerVisible) {
                // Recheck banner visibility every minute
                this.intervalId = setInterval(() => {
                    this.checkBannerVisibility();
                }, 30000);
            }
        },
    }
};
</script>

<style scoped>
.giving-bottom-banner-mobile {
  width: 100vw;
  min-width: 0;
  z-index: 1000;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.08);
  height: 72px;
  transition: height 0.3s;
}

.gbm-inner {
  width: 100vw;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 16px;
}
.gbm-caption {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
  flex: 1;
  /* white-space: nowrap; */
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: -30px;
}
.gbm-cta {
    margin-left: 16px;
    background: #FF7A00;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
    padding: 8px 4px;
    height: 24px;
    width: 72px;
    display: block;
    line-height: 0px;
    margin-top: -30px;
}
.gbm-chevron {
  background: transparent;
  border: none;
  margin-left: 12px;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin: 0 auto;
}
.gbm-collapsed-text {
  width: 100vw;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  padding: 8px 0;
}
@media (min-width: 768px) {
  .giving-bottom-banner-mobile {
    display: none !important;
  }
}
@media (max-width: 767px) {
  .giving-bottom-banner-mobile {
    display: block !important;
  }
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.close {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
  color: #000;
  opacity: 0.5;
  cursor: pointer;
  position: relative;
  top: 68px;
  right: 15px;
  display: flex;
  width: 22px;
}

.close:hover {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  opacity: 0.75;
}

.give-form-not-found {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

#custom-give-form-modal iframe {
  height: 80vh;
  width: 100%;
}

#popup-give-form-container {
  max-height: calc(100vh - 100px) !important;
  width: 616px !important;
  overflow: auto;
  scrollbar-width: none;
}

#popup-give-form-container::-webkit-scrollbar {
  display: none;
}

.custom-loader-container {
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #666;
}

.custom-loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 767px) {
  #popup-give-form-container {
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100vw !important;
    overflow: auto;
    max-height: calc(100vh - 100px) !important;
    scrollbar-width: none;
  }

  #popup-give-form-container::-webkit-scrollbar {
    display: none;
  }
}
</style>
